import { MinimalShell } from "../components/layout/MinimalShell";

const Section = ({ title, children }) => (
  <div className="mb-9">
    <h2 className="font-display text-2xl text-cream mb-3">{title}</h2>
    <div className="text-cream/70 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <MinimalShell>
      <section data-testid="privacy-policy" className="relative pt-32 pb-24 bg-depth-a overflow-hidden">
        <div className="aurora-weave slow" />
        <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8">
          <p className="text-xs tracking-[0.28em] uppercase text-[#E7CC86]/75 mb-4">Gary Malkin Enterprises</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl text-cream mb-3">Privacy Policy</h1>
          <p className="text-cream/50 mb-12">How we handle the information you share with us.</p>

          <Section title="What we collect">
            <p>When you contact us, join a waitlist, or request information, we collect the details you choose to provide — such as your name and email address — so we can respond and keep you informed.</p>
          </Section>
          <Section title="How we use it">
            <p>We use your information to reply to enquiries, deliver requested materials, and share updates about the work. We do not sell your personal information.</p>
          </Section>
          <Section title="Analytics & cookies">
            <p>We use privacy-conscious analytics and cookies to understand how the site is used and to improve the experience. You can manage your preferences at any time — see our Cookie Policy.</p>
          </Section>
          <Section title="Your choices">
            <p>You may request access to, correction of, or deletion of your information by contacting us. You can unsubscribe from updates at any time.</p>
          </Section>
          <Section title="Contact">
            <p>Questions about this policy? Reach us through the Connect page.</p>
          </Section>
        </div>
      </section>
    </MinimalShell>
  );
}
